import { render } from "./Statistiche.vue?vue&type=template&id=3c604a95&scoped=true"
import script from "./Statistiche.vue?vue&type=script&lang=js"
export * from "./Statistiche.vue?vue&type=script&lang=js"

import "./Statistiche.vue?vue&type=style&index=0&id=3c604a95&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c604a95"]])

export default __exports__